import { IGroupedComboBoxItem } from 'grouped-combobox-core';

const pinnedItemKeySuffix = '-pinned';

export function getPinnedItemKey(itemKey: string): string {
    return itemKey + pinnedItemKeySuffix;
}

export function createPinnedVariantItem(item: IGroupedComboBoxItem): IGroupedComboBoxItem {
    return {
        ...item,
        itemKey: getPinnedItemKey(item.itemKey),
    };
}

export function isInPinnedSection(item: IGroupedComboBoxItem): boolean {
    return item.itemKey.endsWith(pinnedItemKeySuffix);
}
